import { render, staticRenderFns } from "./haki.vue?vue&type=template&id=33677178"
import script from "./haki.vue?vue&type=script&lang=js"
export * from "./haki.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QCard,QCardSection,QSelect,QItem,QItemSection,QInput,QBtn,QTooltip,QSeparator,QBtnGroup,QDialog,QFile,QIcon,QCardActions,ClosePopup} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QCard,QCardSection,QSelect,QItem,QItemSection,QInput,QBtn,QTooltip,QSeparator,QBtnGroup,QDialog,QFile,QIcon,QCardActions})
component.options.directives = Object.assign(Object.create(component.options.directives || null), component.options.directives || {}, {ClosePopup})
